<template>
  <div class="swiper-btn-group wd-flex">
    <v-btn
      class="swiper-button swiper-prev mr-3 pa-0"
      :class="{ disabled: props.disabledPrevBtn }"
      min-width="32"
      height="32"
      variant="text"
      aria-label="Prev Button"
      @click="$emit('prev')"
    >
      <FunnowSvgIcon max-width="24" :image-path="'chevron-left.svg'" />
    </v-btn>

    <v-btn
      class="swiper-button swiper-next pa-0"
      :class="{ disabled: props.disabledNextBtn }"
      min-width="32"
      height="32"
      variant="text"
      aria-label="Next Button"
      @click="$emit('next')"
    >
      <FunnowSvgIcon max-width="24" :image-path="'chevron-right.svg'" />
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

interface Props {
  disabledPrevBtn: boolean
  disabledNextBtn: boolean
}

interface Emits {
  prev: []
  next: []
}

const props = defineProps<Props>()

defineEmits<Emits>()
</script>

<style scoped lang="scss">
.swiper-btn-group {
  .swiper-button {
    &.disabled {
      color: $gray60;
      pointer-events: none;
    }
  }
}
</style>
